import { Directive, TemplateRef } from '@angular/core';
import { PageHeaderComponent } from './page-header.component';

@Directive({
  selector: '[mriSharedPageHeaderEyeBrow]',
  standalone: true
})
export class PageHeaderDirective {
  constructor(eyeBrowTemplate: TemplateRef<never>, pageHeader: PageHeaderComponent) {
    pageHeader.eyeBrowTemplate = eyeBrowTemplate;
  }
}
